import { ca } from '@cian/analytics';

import { type IChipsDataService } from 'shared/services/ChipsDataService';

import { type ISliderBlockTypeOneModel } from '../../external/models/SliderBlockTypeOneModel';

/**
 * @description Событие: секция «Среда, жизнь, бизнес» (слайдер с чипами) попала в зону видимости.
 */
export function trackShowEnvironmentLifeBusinessSection(
  sliderBlockTypeOneSlideService: IChipsDataService<ISliderBlockTypeOneModel>,
  label: string,
): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label,
    name: 'oldevent',
    products: sliderBlockTypeOneSlideService.items.map(item => ({
      extra: {
        label: item.chipsOption.label,
        ...item.slides.map((slide, index) => ({
          [`slideTitle.${index + 1}`]: slide.title,
        })),
      },
      id: item.chipsOption.value,
      offerType: 'tab_value',
    })),
  });
}
